import { render, staticRenderFns } from "./WarningCallout.vue?vue&type=template&id=4b1080b4&"
import script from "./WarningCallout.vue?vue&type=script&lang=js&"
export * from "./WarningCallout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports